import { ReactNode } from 'react';
import './UserName.scss';

interface UserNameProps {
    userName: string;
    image?: ReactNode;
    onClick?: () => void;
}

const UserName = (props: UserNameProps) => {
    return (
        <div className={`user-name ${props.onClick ? 'user-name-clickable' : ''}`} onClick={props.onClick}>
            {props?.image}
            <span className='user-name-text'>{props.userName}</span>
        </div>
    );
}

export default UserName;